import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';

export const ForgotPasswordLink = ({ routes: { resetByEmail }, text }) => (
  <Link
    to={resetByEmail}
    className="blueLink"
    onClick={() => {
      trackEvent(TRACKING_ENUMS.EVENT_FORGOT_PASSWORD_SUBMITTED);
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_FORGOT_PASSWORD, {
        page_item_title: text,
      });
    }}
  >
    {text}
  </Link>
);
